import { render } from "./AdminExamDetailView.vue?vue&type=template&id=2e87fdd8&scoped=true"
import script from "./AdminExamDetailView.vue?vue&type=script&lang=js"
export * from "./AdminExamDetailView.vue?vue&type=script&lang=js"

import "./AdminExamDetailView.vue?vue&type=style&index=0&id=2e87fdd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e87fdd8"]])

export default __exports__